<template>
  <div>
    <v-content height="100%">
      <v-card class="elevation-0" height="100%">
        <v-card-text>
          <v-container fluid text-xs-center>
            <v-layout row wrap>
              <v-flex class="text-xs-center xs12">
                <div>
                  <img src="/static/box-orange.png"/><h2>[ {{title}} ]</h2>
                </div>
                <div>
                  <v-form v-model="valid" ref="form" lazy-validation>
                  <v-layout row wrap>
                    <v-flex class="text-xs-center xs12 sm8 offset-sm2 md4 offset-md4">
                      <v-text-field required
                        name="username"
                        label="Username"
                        v-model="username"
                        append-icon="person"
                      ></v-text-field>
                      <v-text-field
                        name="password"
                        label="Enter your password"
                        hint="At least 8 characters"
                        v-model="password"
                        min="8"
                        :append-icon="passwordVisibility ? 'visibility' : 'visibility_off'"
                        @click:append="passwordVisibility = !passwordVisibility"
                        :type="passwordVisibility ? 'password' : 'text'"
                        counter
                      ></v-text-field>
                      <v-btn color="primary" :loading="loading" @click="login" :disabled="!valid" type="submit">Sign in</v-btn>
                    </v-flex>
                  </v-layout>
                  </v-form>
                </div>
              </v-flex>
              <v-flex class="text-xs-left xs12 sm8 offset-sm2 md4 offset-md4">
                <v-card :elevation="0" class="elevation-0">
                  <v-card-actions>
                    <v-btn color="white" depressed tag="a" href="/">
                      <v-icon color="blue">arrow_back</v-icon>
                      <span class="blue--text">กลับสู่หน้าหลัก</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-content>
    <v-footer fixed app>
      <span>&copy; 2017 &nbsp;</span>
      <div class="caption">
        บริษัท เน็ทพลัส ซอฟท์แวร์ จำกัด &nbsp;
        เลขที่ 598 อาคารคิวเฮ้าส์เพลินจิต ชั้น 6 ห้องเลขที่ 2 ถ.เพลินจิต ลุมพินี ปทุมวัน กทม. 10330
      </div>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'Signin',
  data () {
    return {
      title: 'NetPlus Software',
      loading: false,
      forgotPassword: false,
      valid: false,
      passwordVisibility: true,
      username: '',
      password: ''
    }
  },
  methods: {
    login (event) {
      event.preventDefault()
      this.loading = true
      this.$store.dispatch('login', {
        user: {
          username: this.username,
          password: this.password
        }
      }).then(() => {
        this.loading = false
        this.$router.push('/')
      }).catch((errors) => {
        this.loading = false
        this.$snotify.error('ล๊อกอินไม่สำเร็จ! กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่านอีกครั้ง')
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue